import { put, call } from 'redux-saga/effects'; 

import {timesheetSummaryCSVDownload,timesheetFilterDepartments,timesheetFilterSkills,timesheetFilterCrews,timesheetFilterLocations, timesheetList,timesheetDetails,timesheetUpdate,timesheetFilterEvents,timesheetShiftList,timesheetCSVDownload } from '../services/timesheetService';

import * as types from '../actions';

export function* timesheetListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetList, payload);
      yield put({ type: types.TIMESHEET_LIST_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_LIST_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  
  export function* timesheetDetailsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetDetails, payload);
      yield put({ type: types.TIMESHEET_DETAILS_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_DETAILS_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* timesheetUpdateSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetUpdate, payload);
      yield put({ type: types.TIMESHEET_UPDATE_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_UPDATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 
  
  export function* timesheetFilterEventsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetFilterEvents, payload);
      yield put({ type: types.TIMESHEET_FILTER_EVENTS_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_FILTER_EVENTS_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 

  export function* timesheetFilterLocationsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetFilterLocations, payload);
      yield put({ type: types.TIMESHEET_FILTER_LOCATION_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_FILTER_LOCATION_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 

  export function* timesheetFilterDepartmentsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetFilterDepartments, payload);
      yield put({ type: types.TIMESHEET_FILTER_DEPARTMENT_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_FILTER_DEPARTMENT_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 

  export function* timesheetFilterCrewsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetFilterCrews, payload);
      yield put({ type: types.TIMESHEET_FILTER_CREW_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_FILTER_CREW_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 

  export function* timesheetFilterSkillsSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetFilterSkills, payload);
      yield put({ type: types.TIMESHEET_FILTER_SKILL_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_FILTER_SKILL_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
  } 

  export function* timesheetShiftListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetShiftList, payload);
      yield put({ type: types.TIMESHEET_SHIFT_LIST_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_SHIFT_LIST_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }

  export function* timesheetCSVDownloadSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetCSVDownload, payload);
      yield put({ type: types.TIMESHEET_CSV_DOWNLOAD_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_CSV_DOWNLOAD_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  export function* timesheetSummaryCSVDownloadSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(timesheetSummaryCSVDownload, payload);
      yield put({ type: types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS, response });
    } catch(error) {
      yield put({ type: types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }
  